import { normalizeBase64Image, normalizeSearchGender } from "./patientSearch";

function formatProfileDob(details) {
  if (!details?.yearOfBirth) return "";
  const month = details.monthOfBirth
    ? String(details.monthOfBirth).padStart(2, "0")
    : "";
  const day = details.dayOfBirth
    ? String(details.dayOfBirth).padStart(2, "0")
    : "";
  return `${details.yearOfBirth}-${month}-${day}`;
}

function buildAddress(details) {
  const line1 = details.address || details.address_line || "";
  const city = details.city || details.townName || "";
  const district = details.districtName || details.district || "";
  const state = details.stateName || details.state || "";
  const pincode = details.pincode || details.pinCode || "";

  if (!line1 && !city && !district && !state && !pincode) return null;

  return {
    type: "PERMANENT",
    line1,
    city,
    district: district ? String(district).toLowerCase() : "",
    state: state ? String(state).toLowerCase() : "",
    country: "India",
    pincode,
  };
}

/**
 * Maps ABHA profile / healthIdDetails onto the admission patient form
 * (same fields as RegisterPatient.js healthIdDetails effect).
 */
export function mapHealthIdDetailsToPatient(details) {
  if (!details || typeof details !== "object") return {};

  const mapped = {};
  const name = details.fullName || details.name
    || `${details.firstName || ""} ${details.lastName || ""}`.trim();
  if (name) mapped.name = name;

  if (details.gender) mapped.gender = normalizeSearchGender(details.gender);

  const dob = formatProfileDob(details) || details.dob || "";
  if (dob) mapped.dob = dob;

  const mobile = details.mobile || details.phone_no || details.phoneNumber || "";
  if (mobile) {
    mapped.primaryMobile = mobile;
    mapped.contacts = [{ channel: "PHONE", type: "PRIMARY", value: mobile }];
  }

  const email = details.email || details.emailId || "";
  if (email) {
    mapped.contacts = [
      ...(mapped.contacts || []),
      { channel: "EMAIL", type: "PRIMARY", value: email },
    ];
  }

  const abhaAddress = details.healthId
    || details.preferredAbhaAddress
    || details.abhaAddress
    || details.abha_id
    || "";
  if (abhaAddress) mapped.abhaAddress = abhaAddress;

  const abhaNumber = details.healthIdNumber
    || details.ABHANumber
    || details.abhaNumber
    || details.abha_no
    || "";
  if (abhaNumber) mapped.abhaNumber = abhaNumber;

  const address = buildAddress(details);
  if (address) mapped.addresses = [address];

  const photo = details.profilePhoto || details.photo || details.kycPhoto;
  if (photo) mapped.photoUrl = normalizeBase64Image(photo);

  if (details.patient_id) {
    mapped.uhid = details.patient_id;
    mapped.patient_id = details.patient_id;
  }

  return mapped;
}

/**
 * Maps merged patient row from GenerateAbha handleUpdatePatient.
 */
export function mapAbhaPatientMergeToPatient(data) {
  if (!data || typeof data !== "object") return {};
  return mapHealthIdDetailsToPatient({
    ...data,
    name: data.name,
    firstName: data.first_name,
    middleName: data.middle_name,
    lastName: data.last_name,
    abha_id: data.abha_id,
    abha_no: data.abha_no,
    phone_no: data.phone_no,
    address: data.address_line,
    dob: data.dob,
    photo: data.photo,
  });
}
